<template>
  <div id="classmanagement">
    <div class="container admin-wrap">
      <div class="row header mb-2">
        <div class="col-lg-4">
          <h3 class="text-left mb-3">Class Management</h3>
        </div>
        <div class="col-lg-8 actionDiv">
          <el-button-group>
            <el-button type="primary" v-b-modal.newClassModal variant="primary" id="btnAddNewClass">
              <i class="material-icons">playlist_add</i> New Class
            </el-button>
            <el-button type="primary" variant="primary" v-on:click="directToPromotion()" id="btnMassPromotion"
              >Mass Promotion <i class="material-icons"> view_module </i></el-button
            >
            <el-button type="primary" variant="primary" v-on:click="directToTransferIn()"
              >Transfer In <i class="material-icons"> transfer_within_a_station </i></el-button
            >
            <el-button type="primary" variant="primary" v-on:click="directToStudentGraduation()">Graduation <i class="material-icons"> school </i></el-button>
          </el-button-group>
          <!--<b-btn v-b-modal.newClassModal variant="primary">-->
          <!--Mass Promotion-->
          <!--</b-btn>-->
          <!--<b-btn variant="primary" v-on:click="directToPromotion()">-->
          <!--Mass Promotion-->
          <!--</b-btn>-->
        </div>
      </div>
      <div class="">
        <div style="margin-bottom: 10px; text-align: left; padding: 10px 0px; background: #edf0f4; border-radius: 5px" class="row">
          <div class="col-lg-12">
            <el-button v-on:click="openClassCoordinator()" type="primary" variant="primary">
              <i class="material-icons">person_pin</i> Class Coordinator
            </el-button>
            <!--<el-button v-on:click="printAllStudent()" type="primary" variant="primary" id="btnPrintAllStudent">-->
            <!--    <i class="material-icons">print</i> Student Card-->
            <!--</el-button>-->
            <!--<el-button v-on:click="btnPrintBarcodeClick()" type="primary" variant="primary" id="btnPrintBarcode">-->
            <!--    <i class="material-icons">print</i> Barcode (SafeEntry)-->
            <!--</el-button>-->
            <el-button v-on:click="openStudentEmail()" type="primary" variant="primary"> <i class="material-icons">email</i> Student Email </el-button>
            <el-button v-on:click="printAllStudentQR()" type="primary" variant="primary" id="btnPrintAllStudentQR">
              <i class="material-icons">print</i> Student Card (QR)
            </el-button>
          </div>
        </div>
        <div style="margin-bottom: 10px" class="row">
          <div class="col-lg-5">
            <el-input v-model="ClassFilters[0].value" class="search-datatable" placeholder="Search" id="inputSearchClassName">
              <template slot="prepend">
                <i class="material-icons">search</i>
                <span>Search Class Name</span>
              </template>
            </el-input>
          </div>
          <div class="col-lg-7">
            <!--<el-select v-model="ClassFilters[1].value" placeholder="select type"-->
            <!--multiple="multiple" class="float-right">-->
            <!--<el-option-->
            <!--v-for="item in classListFilteritem"-->
            <!--:key="item"-->
            <!--:label="item"-->
            <!--:value="item">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <el-popover placement="bottom-end" width="400" trigger="click">
              <el-checkbox-group v-model="ClassFilters[1].value" class="custom-checkbox">
                <el-checkbox-button v-for="item in classListFilteritem" :label="item" :key="item">{{ item }} </el-checkbox-button>
              </el-checkbox-group>
              <el-button slot="reference" type="primary" round class="float-right large-btn classManage-filter" id="btnFilterByLevel"
                ><i class="material-icons"> tune </i>Filter
              </el-button>
            </el-popover>
          </div>
        </div>
        <data-tables :data="parentClassListInt" :action-col="parentClassListAction" class="classManage-Table" :filters="ClassFilters">
          <el-table-column
            v-for="parentClassListIntInfo in parentClassList"
            :prop="parentClassListIntInfo.prop"
            :label="parentClassListIntInfo.label"
            :key="parentClassListIntInfo.prop"
            sortable="custom"
            id="parentClassList"
          >
          </el-table-column>
        </data-tables>
      </div>
    </div>
    <b-modal
      id="newClassModal"
      size="lg"
      title="Create New Class"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="newClassShowModal"
      v-model="newClassShowModal"
    >
      <div class="row ml-2 mr-2">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-3">
          <label>Level</label>
          <!--<select v-model="ddlClassLevel" class="form-control pro-edt-select form-control-primary">-->
          <!--<option v-for="item in levelList" v-bind:value="item.PK_Course_ID">-->
          <!--{{ item.CRS_Course_Name }}-->
          <!--</option>-->
          <!--</select>-->
          <el-select v-model="ddlClassLevel" placeholder="Select" class="fullwidth">
            <el-option v-for="item in levelList" :key="item.PK_Course_ID" :label="item.CRS_Course_Name" :value="item.PK_Course_ID"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Semester</label>
          <el-select v-model="ddlSemester" placeholder="Select" class="fullwidth">
            <el-option v-for="item in semesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.PK_Semester_ID"> </el-option>
          </el-select>
          <!--<select v-model="ddlSemester" class="form-control pro-edt-select form-control-primary">-->
          <!--<option v-for="item in semesterList" v-bind:value="item.PK_Semester_ID">-->
          <!--{{ item.SMT_Code }}-->
          <!--</option>-->
          <!--</select>-->
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Class Name</label>
          <input type="text" class="form-control" v-model="inputClassName" />
        </div>
        <!--<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
        <!--<label>Programme</label>-->
        <!--<el-select v-model="ddlClassType" placeholder="Select" class="fullwidth">-->
        <!--<el-option-->
        <!--v-for="item in classTypeList"-->
        <!--:key="item.CTY_ClassType"-->
        <!--:label="item.CTY_ClassType"-->
        <!--:value="item.CTY_ClassType">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--&lt;!&ndash;<select v-model="ddlClassType" class="form-control pro-edt-select form-control-primary">&ndash;&gt;-->
        <!--&lt;!&ndash;<option v-for="item in classTypeList" v-bind:value="item.CTY_ClassType">&ndash;&gt;-->
        <!--&lt;!&ndash;{{ item.CTY_ClassType }}&ndash;&gt;-->
        <!--&lt;!&ndash;</option>&ndash;&gt;-->
        <!--&lt;!&ndash;</select>&ndash;&gt;-->
        <!--</div>-->
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Maximum Student</label>
          <input type="text" class="form-control" v-model="inputMaxStudents" @keypress="onlyNumber" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Class Teacher</label>
          <el-select v-model="ddlClassTeacher" filterable clearable placeholder="Select" class="fullwidth">
            <el-option v-for="item in getActiveTeacher()" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
          <!--<select v-model="ddlClassTeacher" class="form-control pro-edt-select form-control-primary">-->
          <!--<option v-for="item in classTeacherList" v-bind:value="item.CONid">-->
          <!--{{ item.CONname }}-->
          <!--</option>-->
          <!--</select>-->
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Mandarin Teacher</label>
          <el-select v-model="ddlMandarinTeacher" filterable clearable placeholder="Select" class="fullwidth">
            <el-option label="N/A" value=" "> </el-option>
            <el-option v-for="item in getActiveTeacher()" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Other Teacher</label>
          <el-select v-model="ddlNewClassAssitantTeacher" filterable placeholder="Select" class="fullwidth">
            <el-option v-for="item in getActiveTeacher()" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Role</label>
          <el-select v-model="ddlNewClassRoleSelection" filterable placeholder="Select" class="fullwidth" style="margin-bottom: 10px">
            <el-option v-for="item in classRoleSelectionList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
          <input type="text" class="form-control" v-model="inputnewClassAssitantTeacherRole" v-if="ddlNewClassRoleSelection === 'Other'" />
          <button v-on:click="AddRole()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Add</button>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="newClassAssitantTeacher.length > 0">
            <data-tables :data="newClassAssitantTeacher" :action-col="newClassAssitantTeacherColumnAction">
              <el-table-column
                v-for="newClassAssitantTeacherColumnInfo in newClassAssitantTeacherColumn"
                :prop="newClassAssitantTeacherColumnInfo.prop"
                :label="newClassAssitantTeacherColumnInfo.label"
                :key="newClassAssitantTeacherColumnInfo.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button v-on:click="closeAssignModal()" class="btn btn-secondary close-modal-btn float-left">Close</button>
        </div>
        <div class="col-lg-6">
          <button v-on:click="createNewProgrmamme('New')" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Next</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="editClassModal" size="lg" title="Edit Class" ok-only ok-variant="secondary" ref="editClassShowModal" hide-footer v-model="editClassShowModal">
      <div class="row ml-2 mr-2">
        <div style="display: none">{{ editSemesterID }} - {{ editCourseID }} - {{ editClassName }} - {{ editClassClassTeacher }}</div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Level</label>
          <input type="text" class="form-control" v-model="inputeditLevel" readonly="readonly" disabled />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Class Name</label>
          <input type="text" class="form-control" v-model="inputEditClassName" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Status</label>
          <el-select v-model="ddlEditClassStatus" filterable placeholder="Select" class="fullwidth">
            <el-option v-for="item in editClassStatusList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
          <!--<select v-model="ddlEditClassStatus" class="form-control pro-edt-select form-control-primary">-->
          <!--<option v-for="item in editClassStatusList" v-bind:value="item">-->
          <!--{{ item }}-->
          <!--</option>-->
          <!--</select>-->
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Maximum Student</label>
          <input type="text" class="form-control" v-model="inputEditMaxStudents" @keypress="onlyNumber" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-2">
          <label>Class Teacher</label>
          <el-select v-model="ddlEditClassTeacher" filterable clearable placeholder="Select" class="fullwidth">
            <el-option v-for="item in getActiveEditTeacher()" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Mandarin Teacher</label>
          <el-select v-model="ddlEditMandarinTeacher" filterable clearable placeholder="Select" class="fullwidth">
            <el-option label="N/A" value=" "> </el-option>
            <el-option v-for="item in getActiveEditTeacher()" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label> Other Teachers</label>
          <el-select v-model="ddlEditClassAssitantTeacher" filterable placeholder="Select" class="fullwidth">
            <el-option v-for="item in getActiveEditTeacher()" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Role</label>

          <el-select v-model="ddlEditClassRoleSelection" filterable placeholder="Select" class="fullwidth" style="margin-bottom: 10px">
            <el-option v-for="item in classRoleSelectionList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
          <input type="text" class="form-control" v-model="inputeditClassAssitantTeacherRole" v-if="ddlEditClassRoleSelection === 'Other'" />
          <button v-on:click="EditAddRole()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Add</button>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="editClassAssitantTeacher.length > 0">
            <data-tables :data="editClassAssitantTeacher" :action-col="editClassAssitantTeacherColumnAction">
              <el-table-column
                v-for="editClassAssitantTeacherColumnInfo in editClassAssitantTeacherColumn"
                :prop="editClassAssitantTeacherColumnInfo.prop"
                :label="editClassAssitantTeacherColumnInfo.label"
                :key="editClassAssitantTeacherColumnInfo.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button @click="backtoClassList()" class="btn btn-secondary float-left">Back</button>
        </div>
        <div class="col-lg-6">
          <button v-on:click="updateClass()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Save</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="assignClassModal"
      size="lg"
      title="Assign Students"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="assignClassShowModal"
      v-model="assignClassModal"
    >
      <div class="">
        <div style="display: none">{{ assignClassLevelID }} - {{ assignClassID }} - {{ assignClassSemID }}</div>
        <div class="">
          <div v-if="assignStudentsListInt.length < 1" class="empty-list_image">
            <strong>No Record ...</strong>
            <img src="../assets/promotion.jpg" />
          </div>
          <div v-if="assignStudentsListInt.length > 0">
            <el-row style="margin-bottom: 10px" class="classManage-ActionBar">
              <el-col :span="23">
                <!--<el-input v-model="filters[0].value">-->
                <!--<template slot="prepend">Search</template>-->
                <!--</el-input>-->
                <el-input v-model="assignStudentsListSearchFilter">
                  <template slot="prepend">Search</template>
                </el-input>
              </el-col>
              <!--<el-col :span="7" :offset="1">-->
              <!--<el-button type="primary" round @click="ViewStudentToClassInner()">View Assigned Student-->
              <!--</el-button>-->
              <!--</el-col>-->
            </el-row>
            <!--<data-tables :data="assignStudentsListInt" :filters="filters" layout="table"-->
            <!--:pagination-props="{ background: true, pageSizes: [2, 3, 4] }"-->
            <!--@selection-change="changeSelection" :row-key="getRowKey" ref="articleTable">-->
            <!--<el-table-column type="selection" width="55" :reserve-selection="true">-->
            <!--</el-table-column>-->
            <!--<el-table :data="assignStudentsListInt.filter(data => !assignStudentsListSearchFilter || data.Full_Name.toLowerCase().includes(assignStudentsListSearchFilter.toLowerCase()))"-->
            <!--@selection-change="changeSelection" :row-key="getRowKey" ref="articleTable">-->
            <el-table
              :data="
                assignStudentsListInt
                  .filter(data => !assignStudentsListSearchFilter || data.Full_Name.toLowerCase().includes(assignStudentsListSearchFilter.toLowerCase()))
                  .slice((assignStudentsListCurrentPage - 1) * assignStudentsListPageSize, assignStudentsListCurrentPage * assignStudentsListPageSize)
              "
              @selection-change="changeSelection"
              :row-key="getRowKey"
            >
              <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
              <el-table-column
                v-for="assignStudentsListInfo in assignStudentsList"
                :prop="assignStudentsListInfo.prop"
                :label="assignStudentsListInfo.label"
                :key="assignStudentsListInfo.prop"
                sortable
              >
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="assignStudentsListChangePage"
              @size-change="assignStudentsListChangePageSize"
              :page-sizes="[20, 40, 60, 80]"
              :page-size="assignStudentsListPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="assignStudentsListTotal"
            >
            </el-pagination>
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="row">
          <div class="col-lg-6">
            <button v-on:click="backtoClassList()" class="btn btn-secondary close-modal-btn float-left">Back</button>
          </div>
          <div class="col-lg-6">
            <button
              v-on:click="assignClass()"
              class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch float-right"
              :disabled="assignStudentsListInt.length < 1"
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="ViewClassModal"
      size="lg"
      title="View Students"
      ok-only
      ok-variant="secondary"
      ref="ViewClassModal"
      ok-title="Close"
      hide-footer
      v-model="ViewClassModal"
    >
      <div class="">
        <div style="display: none">{{ assignClassLevelID }} - {{ assignClassID }}</div>
        <div v-if="currentStudent.length < 1" class="empty-list_image">
          <strong>No Record ...</strong>
          <img src="../assets/promotion.jpg" />
        </div>
        <div class="" v-if="currentStudent.length > 0">
          <div>
            <h1>Active</h1>
          </div>
          <div>
            <data-tables :data="currentStudent" @selection-change="viewStudentsSelection">
              <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
              <el-table-column
                v-for="studentList in currentStudentList"
                :prop="studentList.prop"
                :label="studentList.label"
                :key="studentList.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </div>
        </div>
        <div class="" v-if="currentStudentPending.length > 0">
          <div>
            <h1>Pending</h1>
          </div>
          <div>
            <data-tables :data="currentStudentPending" @selection-change="viewStudentsPendingSelection">
              <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
              <el-table-column
                v-for="currentStudentPendingListInfo in currentStudentPendingList"
                :prop="currentStudentPendingListInfo.prop"
                :label="currentStudentPendingListInfo.label"
                :key="currentStudentPendingListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
      <hr class="custom-hr" />
      <div class="row">
        <div class="col-lg-6">
          <button @click="closeAssignModal" class="btn btn-secondary waves-effect waves-light m-r-10 btnFamilyIDSearch float-left">Close</button>
        </div>
        <div class="col-lg-6" v-if="viewStudentsSelectionList.length > 0 || viewStudentsPendingSelectionList.length > 0">
          <el-button-group class="float-right">
            <el-button v-if="viewStudentsPendingSelectionList.length > 0" type="warning" @click="printPendingSafeEntry()">
              Print Safe Entry(Pending only)</el-button
            >
            <el-button type="primary" @click="printStudentCard()">Print Students Card</el-button>
          </el-button-group>
        </div>
      </div>
    </b-modal>
    <b-modal id="ClassListModal" size="lg" title="Class List" ok-only ok-variant="secondary" hide-footer ref="classListShowModal" v-model="ClassListModal">
      <div class="row ml-2 mr-2">
        <div style="display: none">
          {{ classListSemesterID }} - {{ classListCourseID }} - {{ classListClassName }} - {{ classListLevelName }} - {{ classListMaxStudents }} -
          {{ classListClassTeacher }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="">
            <el-button-group class=" ">
              <el-button type="primary" v-on:click="editClass()" variant="primary"><i class="material-icons"> edit </i> Edit Class </el-button>
              <el-button type="primary" v-on:click="createNewProgrmamme('Edit')" variant="primary"
                ><i class="material-icons"> note_add </i> Create New Programme
              </el-button>
            </el-button-group>
          </div>
          <div class="totalNumberOfStudentAssignedToClass" v-if="totalNumberOfStudentAssignedToClass">
            <label> Total Student Assigned: {{ totalNumberOfStudentAssignedToClass }} </label>
          </div>
          <div v-if="classListInt.length > 0">
            <data-tables :data="classListInt" class="classManage-Table" :action-col="classListAction" :filters="ClassFilters">
              <el-table-column
                v-for="classListInfo in classList"
                :prop="classListInfo.prop"
                :label="classListInfo.label"
                :key="classListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column label="Assign Students" min-width="100px">
                <template slot-scope="scope">
                  <el-button
                    v-for="assignStudents in assignStudentToClass(scope.row)"
                    :key="assignStudents.name"
                    type="primary"
                    @click="assignStudents.handler"
                  >
                    {{ assignStudents.name }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="View Students" min-width="100px">
                <template slot-scope="scope">
                  <el-button v-for="assignStudents in ViewStudentToClass(scope.row)" :key="assignStudents.name" type="primary" @click="assignStudents.handler">
                    {{ assignStudents.name }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="Schedule" min-width="100px">
                <template slot-scope="scope">
                  <el-button @click="showScheduleClassModal(scope.row)"><span class="el-icon-date"></span></el-button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button v-on:click="closeAssignModal()" class="btn btn-secondary close-modal-btn float-left">Close</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="newProgrammeModal"
      size="lg"
      title="Create New Programme"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="newProgrammeShowModal"
      v-model="newProgrammeShowModal"
    >
      <div class="row ml-2 mr-2">
        <div style="display: none">
          {{ programmeLevelID }} - {{ programmeSemID }} - {{ programmeClassName }} - {{ programmeMaxStudent }} - {{ programmeClassTeacher }} -
          {{ programmeSaveType }}
        </div>
        <div class="col-lg-12" v-if="currentClassTypeList.length > 0">
          <label>Programme</label>
        </div>
        <div class="col-lg-6">
          <el-select v-model="ddlClassType" placeholder="Select" class="fullwidth" v-if="currentClassTypeList.length > 0">
            <el-option
              v-for="item in currentClassTypeList"
              :key="item.CTY_ClassType"
              :label="item.CTY_ClassType"
              :value="item.CTY_ClassType"
              :disabled="item.disabled === true"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-12">
          <div v-if="currentClassTypeList.length < 1" class="empty-list_image">
            <strong class="text-center">All Programme has been created.</strong>
            <img src="../assets/promotion.jpg" />
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-6">
          <button v-on:click="backtoClassList()" class="btn btn-secondary close-modal-btn float-left" v-if="showbackBtn === true">Back</button>
        </div>
        <div class="col-lg-6">
          <button v-on:click="saveClass()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch" :disabled="currentClassTypeList < 1">
            Create
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="deleteClassModal" size="lg" title="Delete Class" ok-only ok-variant="secondary" hide-footer ref="deleteClassShowModal">
      <div class="col-lg-12">
        <h1>Are you sure to delete class {{ deleteCurrentClassName }} ?</h1>
      </div>
      <hr class="custom-hr" />
      <div class="col-lg-12">
        <button v-on:click="removeClassProgramme(deleteCurrentClassID)" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">
          Confirm Delete
        </button>
      </div>
    </b-modal>
    <b-modal id="scheduleClassModal" size="lg" title="Schedule Class Assignment" ok-only ok-variant="secondary" hide-footer ref="scheduleClassShowModal">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Schedule Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputscheduleClassDate"
              format="dd/MM/yyyy"
              @input="getScheduleAssignStudents()"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a date"
              :picker-options="inputscheduleClassDateDatePickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="assignScheduleStudentsListInt.length < 1" class="empty-list_image">
            <strong>No Record ...</strong>
            <img src="../assets/promotion.jpg" />
          </div>
          <div v-if="assignScheduleStudentsListInt.length > 0">
            <hr class="custom-hr" />
            <el-row style="margin: 20px 0 20px 0" class="classManage-ActionBar">
              <el-col :span="24">
                <el-input v-model="assignScheduleStudentsListSearchFilter">
                  <template slot="prepend">Search</template>
                </el-input>
              </el-col>
            </el-row>
            <el-table
              :data="
                assignScheduleStudentsListInt
                  .filter(
                    data =>
                      !assignScheduleStudentsListSearchFilter || data.Full_Name.toLowerCase().includes(assignScheduleStudentsListSearchFilter.toLowerCase()),
                  )
                  .slice(
                    (assignScheduleStudentsListCurrentPage - 1) * assignScheduleStudentsListPageSize,
                    assignScheduleStudentsListCurrentPage * assignScheduleStudentsListPageSize,
                  )
              "
              @selection-change="changeScheduleSelection"
              :row-key="getRowKey"
            >
              <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
              <el-table-column
                v-for="assignScheduleStudentsListInfo in assignScheduleStudentsList"
                :prop="assignScheduleStudentsListInfo.prop"
                :label="assignScheduleStudentsListInfo.label"
                :key="assignScheduleStudentsListInfo.prop"
                sortable
              >
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="assignScheduleStudentsListChangePage"
              @size-change="assignScheduleStudentsListChangePageSize"
              :page-sizes="[20, 40, 60, 80]"
              :page-size="assignScheduleStudentsListPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="assignScheduleStudentsListTotal"
            >
            </el-pagination>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="assignScheduleStudentsListInt.length > 0">
          <hr class="custom-hr" />
          <div>
            <div class="col-lg-12">
              <button v-on:click="assignScheduleClass()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch float-right">Save</button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="printAllStudentModal" size="lg" title="Print All student" hide-footer ref="showPrintAllStudentModal" ok-only ok-variant="secondary">
      <StudentCard
        @setTags="setTags"
        @AddComponentValue="AddComponentValue"
        @ClearSelectedItems="ClearSelectedItems"
        :SelectedStudentListInt="SelectedStudentListInt"
        @PrintPreviewBtnClick="PrintPreviewBtnClick"
        @changeSelection="changeSelection"
        :SelectedStudentList="SelectedStudentList"
      />
    </b-modal>
    <b-modal id="printBarcodeModal" size="lg" title="Print Barcode (SafeEntry)" hide-footer ref="printBarcodeModal" ok-only ok-variant="secondary">
      <div id="printBarcode" class="container">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <EventTagsComponent @tags="setTags" ref="refReset"></EventTagsComponent>
          <el-button-group>
            <el-button class="col-xs-2" v-on:click="AddComponentBarcode()">Add Student Barcode</el-button>
            <el-button class="col-xs-2" v-on:click="ClearSelectedItems()">Clear</el-button>
          </el-button-group>
        </div>
        <hr />

        <div v-if="SelectedStudentListInt.length > 0" class="datatable_group">
          <h5 class="text-left mb-3"><p class="font-weight-bold">Selected Student List</p></h5>
          <div class="datatable-form__submit text-right">
            <button class="btn btn-success searchbtn" id="btnPreviewBarcode" v-on:click="PrintBarcode()">Print&Preview</button><br />
          </div>
          <data-tables
            :data="SelectedStudentListInt"
            @selection-change="changeSelection"
            width="55"
            stripe
            tooltip-effect="light"
            border
            ref="SelectedStudentListTable"
          >
            <!--                    <el-table-column type="selection" width="55" :reserve-selection="true">-->
            <!--                    </el-table-column>-->
            <el-table-column v-for="item in SelectedStudentList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
          </data-tables>
        </div>

        <div v-if="allPendingStudentInt.length > 0">
          <label><h5>Pending</h5></label>
          <div class="col-lg-5 float-right">
            <el-popover placement="bottom-end" width="400" trigger="click">
              <el-checkbox-group v-model="PendingClassFilters[1].value" class="custom-checkbox">
                <el-checkbox-button v-for="item in PendingClassListFilteritem" :label="item" :key="item">{{ item }} </el-checkbox-button>
              </el-checkbox-group>
              <el-button slot="reference" type="primary" round class="float-right large-btn classManage-filter" id="btnPendingFilterByLevel"
                ><i class="material-icons"> tune </i>Filter
              </el-button>
            </el-popover>
          </div>

          <data-tables
            :data="allPendingStudentInt"
            @selection-change="changePendingSelection"
            layout="table"
            :row-key="getRowKey"
            :filters="PendingClassFilters"
          >
            <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
            <el-table-column v-for="item in allPendingStudentList" :prop="item.prop" :label="item.label" :key="item.prop" sortable> </el-table-column>
          </data-tables>
          <br />
          <el-button type="warning" class="float-right large-btn" v-on:click="printPendingSafeEntry('PrintAllSafeEntry')">Print Safe Entry</el-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="classCoordinatorModel" size="lg" title="Class Coordinator" ok-only ok-variant="secondary" hide-footer ref="classCoordinatorModel">
      <div>
        <data-tables :data="coordinatorClassListInt" class="classManage-Table">
          <el-table-column label="" width="50px">
            <template slot-scope="scope">
              <span>
                <i class="material-icons" style="color: #ec4050" v-if="scope.row.CoorList.length < 1">info</i>
              </span>
            </template>
          </el-table-column>
          <el-table-column v-for="item in coordinatorClassList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
          <el-table-column label="Coordinator">
            <template slot-scope="scope">
              <span v-if="scope.row.CoorList.length > 0">
                <span :class="!scope.row.followMain ? 'coorNameNonMain' : ''">
                  {{ scope.row.CoorList[0].Name }}
                </span>
                <span :class="!scope.row.followMain ? 'coorNameLevel1NonMain' : 'coorNameLevel1Main'" style="display: inline-block"> Level 1 </span>
              </span>
              <span v-if="scope.row.CoorList.length < 1">
                <span class="coorNoAssign">No Coordinator Assign</span>
              </span>
              <span v-if="scope.row.CoorList.length > 0">
                <el-popover placement="bottom" trigger="click">
                  <div style="padding: 10px; background: #536170; border-radius: 5px; min-width: 400px">
                    <div style="color: rgba(255, 255, 255, 0.59); border-bottom: 1px solid rgba(221, 230, 252, 0.26); padding: 10px 0; margin-bottom: 20px">
                      Coordinator List
                    </div>
                    <div v-for="item in scope.row.CoorList">
                      <div class="row" style="color: #ffffff; margin-bottom: 20px">
                        <div class="col-lg-8">
                          {{ item.Name }}
                        </div>
                        <div class="col-lg-4" style="text-align: right">
                          <span style="padding: 5px; background: #47525e">Level {{ item.Level }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-button slot="reference" class="coorModeList"><i class="material-icons">more_horiz</i></el-button>
                </el-popover>
              </span>
              <span>
                <el-button
                  slot="reference"
                  :class="scope.row.followMain || scope.row.CoorList.length < 1 ? 'coorModeEditMain' : 'coorModeEditNonMain'"
                  @click="updateCoordinatorModel(scope.row)"
                >
                  <i class="material-icons">edit</i>
                </el-button>
              </span>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </b-modal>
    <b-modal id="updateCoordinatorModel" size="lg" title="Update Coordinator" ok-only ok-variant="secondary" hide-footer ref="updateCoordinatorModel">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <label>Coordinator</label>
            <el-select v-model="updateCoordinatorClassTeacher" placeholder="Select" class="fullwidth" filterable v-if="AllStaffListBySchoolList.length > 0">
              <el-option v-for="item in AllStaffListBySchoolList" :key="item.CONid" :label="item.CONname" :value="item.CONid"> </el-option>
            </el-select>
          </div>
          <div class="col-lg-4">
            <label>Level</label>
            <label>{{ updateCoordinatorClassLevel }}</label>
          </div>
          <div class="col-lg-2" style="margin: auto">
            <span v-on:click="addCoorToList()" style="background: #426dff; border-radius: 5px; padding: 5px; cursor: pointer">
              <i class="material-icons" style="color: #ffffff">playlist_add</i>
            </span>
          </div>
          <div class="col-lg-12" v-if="updateCoordinatorClassList.length > 0">
            <data-tables :data="updateCoordinatorClassList" :action-col="updateCoordinatorClassAction" class="classManage-Table">
              <el-table-column
                v-for="updateCoordinatorClassInfo in updateCoordinatorClass"
                :prop="updateCoordinatorClassInfo.prop"
                :label="updateCoordinatorClassInfo.label"
                :key="updateCoordinatorClassInfo.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
          </div>
          <div class="col-lg-12">
            <button v-on:click="updateClassCoordinator()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Save</button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="studentEmailModel" size="lg" title="Student Email" ok-only ok-variant="secondary" hide-footer ref="studentEmailModel">
      <div>
        <button v-if="showActiveEmailList" v-on:click="loadStudentEmailList()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">
          Load Student Without Email List
        </button>
        <button v-if="!showActiveEmailList" v-on:click="loadStudentEmailList()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">
          Load Student With Email List
        </button>
      </div>
      <div v-if="showActiveEmailList">
        <div v-if="studentEmailListActiveEmailInt.length < 1" class="empty-list_image">
          <strong>No Record ...</strong>
          <img src="../assets/promotion.jpg" />
        </div>
        <div v-if="studentEmailListActiveEmailInt.length > 0">
          <div style="margin-top: 10px">
            <el-input
              v-model="inputSearchStudentEmailListActiveEmail"
              class="mb-2"
              style="width: calc(100% - 50px)"
              placeholder="Search First Name / Class / Level"
            >
            </el-input>
            <span><i class="material-icons" style="width: 50px">search</i></span>
          </div>
          <data-tables :data="filterActiveStudentEmailList()" class="classManage-Table">
            <el-table-column
              v-for="studentEmailListActiveEmailInfo in studentEmailListActiveEmail"
              :prop="studentEmailListActiveEmailInfo.prop"
              :label="studentEmailListActiveEmailInfo.label"
              :key="studentEmailListActiveEmailInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
      <div v-if="!showActiveEmailList">
        <div v-if="studentEmailListNonActiveEmailInt.length < 1" class="empty-list_image">
          <strong>No Record ...</strong>
          <img src="../assets/promotion.jpg" />
        </div>
        <div v-if="studentEmailListNonActiveEmailInt.length > 0">
          <div style="margin-top: 10px">
            <el-input
              v-model="inputSearchStudentEmailListNonActiveEmail"
              class="mb-2"
              style="width: calc(100% - 50px)"
              placeholder="Search First Name / Class / Level"
            >
            </el-input>
            <span><i class="material-icons" style="width: 50px">search</i></span>
          </div>
          <div>
            <data-tables :data="filterNonActiveStudentEmailList()" class="classManage-Table" @selection-change="changeStudentEmailSelection">
              <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
              <el-table-column
                v-for="studentEmailListNonActiveEmailInfo in studentEmailListNonActiveEmail"
                :prop="studentEmailListNonActiveEmailInfo.prop"
                :label="studentEmailListNonActiveEmailInfo.label"
                :key="studentEmailListNonActiveEmailInfo.prop"
                sortable="custom"
              >
              </el-table-column>
            </data-tables>
            <button v-on:click="createStudentEmail()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Submit</button>
          </div>
        </div>
      </div>
    </b-modal>
    <v-tour
      name="classManagementPageVueTourName"
      :steps="classManagementPageVueTour"
      :options="classManagementPageVueTourOptions"
      :callbacks="classManagementPageVueTourCallBacks"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="tourStop()">Finish</button>
                <button class="v-step__button" @click="tour.nextStep">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep !== 0 && tour.currentStep !== 7">
              <div slot="actions">
                <button class="v-step__button" @click="tourStop()">Skip tour</button>
                <button class="v-step__button" @click="tour.previousStep">Previous</button>
                <button class="v-step__button" @click="tour.nextStep">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep === 7">
              <div slot="actions">
                <button class="v-step__button" @click="tourStop()">Finish</button>
                <button class="v-step__button" @click="tour.previousStep">Previous</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <div style="display: none">
      <el-button type="primary" class="btn btn-primary waves-effect waves-light m-r-10 float-left" @click="classManagementPageVueTourStart()">
        Guided Tour
      </el-button>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import EventTagsComponent from '../components/Event_Tags_Component'
import Cookies from 'js-cookie'
import StudentCard from './classManagement/studentCard'
import ConfigAdmin from '../config/configAdmin'

export default {
  components: { StudentCard, EventTagsComponent },
  name: 'ClassManagement',
  async created() {
    //await this.getClass();
    await this.getParentClassList()
    await this.getLevel()
    await this.getAcademicYear()
    await this.getClassType()
    await this.getClassTeacher()
    await this.getAllStaffListBySchool()
  },
  async mounted() {
    this.userType = Cookies.get('userTypeSession')
    window.addEventListener('load', () => {
      if (this.$route.query.clsName !== undefined) {
        this.ClassFilters[0].value = this.$route.query.clsName
      }

      if (this.$route.query.tour === 'YES') {
        this.classManagementPageVueTourStart()
      }
    })

    this.getAllPendingStudent()
  },
  data() {
    return {
      currentClassProgs: [],
      assignClassModal: false,
      newClassShowModal: false,
      editClassShowModal: false,
      newProgrammeShowModal: false,
      ClassListModal: false,
      ViewClassModal: false,
      showbackBtn: false,
      ddlClassLevel: '',
      ddlSemester: '',
      inputClassName: '',
      ddlClassType: '',
      ddlClassTeacher: '',
      ddlMandarinTeacher: '',
      inputMaxStudents: '',
      ddlEditClassStatus: '',
      inputEditClassName: '',
      inputEditMaxStudents: '',
      inputeditLevel: '',
      assignClassLevelID: '',
      assignClassID: '',
      classListSemesterID: '',
      classListCourseID: '',
      classListClassName: '',
      classListLevelName: '',
      classListMaxStudents: '',
      programmeLevelID: '',
      programmeSemID: '',
      programmeClassName: '',
      programmeMaxStudent: '',
      programmeClassTeacher: '',
      programmeSaveType: '',
      editSemesterID: '',
      editCourseID: '',
      editClassName: '',
      editClassID: '',
      assignStudentsListSearchFilter: '',
      totalNumberOfStudentAssignedToClass: '',
      assignClassSemID: '',
      classListClassTeacher: '',
      editClassClassTeacher: '',
      ddlEditClassTeacher: '',
      ddlEditMandarinTeacher: '',

      ddlEditClassAssitantTeacher: '',
      ddlNewClassAssitantTeacher: '',
      inputnewClassAssitantTeacherRole: '',
      inputeditClassAssitantTeacherRole: '',
      classRoleSelectionList: ConfigAdmin.classManagement.classRoleSelectionList,
      ddlNewClassRoleSelection: '',
      ddlEditClassRoleSelection: '',
      programmeClassAssitantTeacher: [],

      newClassAssitantTeacher: [],
      newClassAssitantTeacherColumn: [
        {
          prop: 'Name',
          label: 'Name',
        },
        {
          prop: 'Role',
          label: 'Role',
        },
      ],
      newClassAssitantTeacherColumnAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.newClassAssitantTeacher.splice(this.newClassAssitantTeacher.indexOf(row), 1)
            },
            label: '',
          },
        ],
      },

      editClassAssitantTeacher: [],
      editClassAssitantTeacherColumn: [
        {
          prop: 'Name',
          label: 'Name',
        },
        {
          prop: 'Role',
          label: 'Role',
        },
      ],
      editClassAssitantTeacherColumnAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              this.editClassAssitantTeacher.splice(this.editClassAssitantTeacher.indexOf(row), 1)
            },
            label: '',
          },
        ],
      },

      levelList: [],
      semesterList: [],
      classTypeList: [],
      currentClassTypeList: [],
      classTeacherList: [],
      classListInt: [],
      classListFilteritem: [],
      editClassStatusList: ['Active', 'Closed'],
      assignStudentsListInt: [],

      viewStudentsSelectionList: [],
      viewStudentsPendingSelectionList: [],
      currentSemID: '',
      currentCrsID: '',

      deleteCurrentClassName: '',
      deleteCurrentClassID: '',

      scheduleClassID: '',
      inputscheduleClassDate: '',
      assignScheduleStudentsListSearchFilter: '',

      inputscheduleClassDateDatePickerOptions: {
        disabledDate(time) {
          return time <= new Date()
        },
      },

      classList: [
        {
          prop: 'CLS_ClassName',
          label: 'Class Name',
        },
        {
          prop: 'CLS_Batch',
          label: 'Programme',
          // }, {
          //     prop: "CLS_Class_Max_Students",
          //     label: "Max Students"
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
          // }, {
          //     prop: "PK_Class_ID",
          //     label: "class id"
        },
      ],
      classListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },
            handler: row => {
              // this.removeClassProgramme(row.PK_Class_ID);
              this.deleteCurrentClassName = row.CLS_ClassName + ' - ' + row.CLS_Batch
              this.deleteCurrentClassID = row.PK_Class_ID
              this.$refs.deleteClassShowModal.show()
            },
            label: '',
          },
        ],
      },

      multipleSelection: [],
      assignStudentsListCurrentPage: 1,
      assignStudentsListPageSize: 20,
      assignStudentsListTotal: 0,
      assignStudentsList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Current Class',
        },
        {
          prop: 'CLS_Batch',
          label: 'Batch',
        },
      ],
      ClassFilters: [
        {
          value: '',
          prop: 'CLS_ClassName',
        },
        {
          value: [],
          prop: 'CRS_Course_Name',
        },
      ],
      // filters: [{
      //     value: '',
      //     prop: 'Full_Name',
      // }],

      currentStudent: [],
      currentStudentList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
      ],
      tempRow: '',

      currentStudentPending: [],
      currentStudentPendingList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'SCRS_From_Date_convert',
          label: 'Course Start Date',
        },
      ],

      parentClassListInt: [],
      parentClassList: [
        {
          prop: 'CLS_ClassName',
          label: 'Class Name',
        },
        {
          prop: 'Average_MaxStudents',
          label: 'Max Students',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'SMT_Year',
          label: 'Year',
        },
      ],
      parentClassListAction: {
        label: 'Edit',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.classListSemesterID = row.CLS_FK_Semester_ID
              this.classListCourseID = row.CLS_FK_Course_ID
              this.classListClassName = row.CLS_ClassName
              this.classListLevelName = row.CRS_Course_Name
              this.classListMaxStudents = row.Average_MaxStudents
              this.classListClassTeacher = row.TeacherInCharge
              this.getClass()
              this.$refs.classListShowModal.show()
              this.showbackBtn = true
            },
            label: 'Edit',
          },
        ],
      },

      assignScheduleStudentsListInt: [],
      multipleScheduleSelection: [],
      assignScheduleStudentsListCurrentPage: 1,
      assignScheduleStudentsListPageSize: 20,
      assignScheduleStudentsListTotal: 0,
      assignScheduleStudentsList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Current Class',
        },
        {
          prop: 'CLS_Batch',
          label: 'Batch',
        },
      ],

      //vue tour
      classManagementPageVueTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      classManagementPageVueTourCallBacks: {
        onPreviousStep: this.classManagementPageVueTourCallBacksPreviousSteps,
        onNextStep: this.classManagementPageVueTourCallBacksNextSteps,
      },
      classManagementPageVueTour: [
        //new class
        {
          target: '#btnAddNewClass',
          content: `<div>Step 1 / 8 <br> Create new class</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '#btnAddNewClass',
          content: `<div>Step 2 / 8 <br> Create new class <br> Select & fill in all the fields, click Next button <br> Select Programme, click Create button</div>`,
          params: {
            placement: 'bottom',
          },
        },
        //edit class
        {
          target: '#inputSearchClassName',
          content: `<div>Step 3 / 8 <br> Edit class <br> Fill in to search class name</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '#btnFilterByLevel',
          content: `<div>Step 4 / 8 <br> Edit class <br> Click and select to filter class by level</div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '#parentClassList',
          content: `<div>Step 5 / 8 <br> Edit class <br> Click Edit button to edit</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#parentClassList',
          content: `<div>Step 6 / 8 <br> Edit class <br> Click Edit Class button to edit class information <br> Click Create New Programme button to create new programme for the class</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#parentClassList',
          content: `<div>Step 7 / 8 <br> Edit class <br> Inside programme list, click Assign button to assign student belong to the level into the class programme < br> click View button to view student that assigned to the class programme</div>`,
          params: {
            placement: 'top',
          },
        },
        //mass promotion
        {
          target: '#btnMassPromotion',
          content: `<div>Step 8 / 8 <br> Mass promotion <br> Redirect to the promotion page</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour

      //todo save and print later
      saveAndPrintLaterList: [],
      arr_semID: [],
      isClick: false,
      viewSavedPrintListInt: [],
      viewSavedPrintList: [
        {
          prop: 'FullName',
          label: 'Student Name',
        },
        {
          prop: 'IndexNo',
          label: 'Student No',
        },
      ],
      totalSavedStudentInt: [],
      totalSavedStudent: [
        {
          prop: 'FullName',
          label: 'Student Name',
        },
        {
          prop: 'IndexNo',
          label: 'Student No',
        },
      ],
      //todo save and print later
      spdSelection: [],
      SelectedStudentListInt: [],
      SelectedStudentList: [
        {
          prop: 'FullName',
          label: 'Student Name',
        },
        {
          prop: 'IndexNo',
          label: 'Index No',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Class',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Course',
        },
      ],
      SelectedStudentListAction: {
        label: 'More Info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              //    console.log(row);
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More Info',
          },
        ],
      },

      //todo PrintBarcode filter by class
      showDialog: false,
      multiplePendingSelection: [],
      allPendingStudentInt: [],
      allPendingStudentList: [
        {
          prop: 'Index_No',
          label: 'Student NO',
        },
        {
          prop: 'First_Name',
          label: 'Student Name',
        },
        {
          prop: 'CLS_Batch',
          label: 'Batch',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Class Name',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Course Name',
        },
      ],
      PendingClassListFilteritem: [],
      PendingClassFilters: [
        {
          value: '',
          prop: 'CLS_ClassName',
        },
        {
          value: [],
          prop: 'CRS_Course_Name',
        },
      ],
      //todo PrintBarcode filter by class

      coordinatorClassListInt: [],
      coordinatorClassList: [
        {
          prop: 'SemName',
          label: 'Academic Year',
        },
        {
          prop: 'CrsName',
          label: 'Level',
        },
        {
          prop: 'ClassFullName',
          label: 'Class',
        },
      ],
      mainCoordinatorClassList: [],
      currentCoordinatorClassList: [],
      AllStaffListBySchoolList: [],
      updateCoordinatorClassList: [],
      updateCoordinatorClass: [
        {
          prop: 'Name',
          label: 'Name',
        },
        {
          prop: 'Level',
          label: 'Level',
        },
      ],
      updateCoordinatorClassAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.updateCoordinatorClassList.splice(this.updateCoordinatorClassList.indexOf(row), 1)

              this.updateCoordinatorClassLevel = this.updateCoordinatorClassList.length + 1

              let currentLevel = 0
              this.updateCoordinatorClassList = this.updateCoordinatorClassList.map(m => {
                currentLevel++

                m.Level = currentLevel

                return m
              })
            },
            label: 'Delete',
          },
        ],
      },
      updateCoordinatorClassTeacher: '',
      updateCoordinatorClassLevel: '',

      studentEmailListActiveEmailInt: [],
      studentEmailListActiveEmail: [
        {
          prop: 'IndexNo',
          label: 'Student ID',
        },
        {
          prop: 'FirstName',
          label: 'First Name',
        },
        {
          prop: 'MiddleName',
          label: 'Middle Name',
        },
        {
          prop: 'LastName',
          label: 'Family Name',
        },
        {
          prop: 'Email',
          label: 'Email',
        },
        {
          prop: 'Password',
          label: 'Password',
        },
        {
          prop: 'Class',
          label: 'Class',
        },
        {
          prop: 'Level',
          label: 'Level',
        },
      ],

      studentEmailListNonActiveEmailInt: [],
      studentEmailListNonActiveEmail: [
        {
          prop: 'IndexNo',
          label: 'Student ID',
        },
        {
          prop: 'FirstName',
          label: 'First Name',
        },
        {
          prop: 'MiddleName',
          label: 'Middle Name',
        },
        {
          prop: 'LastName',
          label: 'Family Name',
        },
        {
          prop: 'Class',
          label: 'Class',
        },
        {
          prop: 'Level',
          label: 'Level',
        },
      ],

      showActiveEmailList: true,
      studentEmailSelection: [],
      inputSearchStudentEmailListActiveEmail: '',
      inputSearchStudentEmailListNonActiveEmail: '',
      modal: '',
    }
  },
  methods: {
    getRowKey(row) {
      return row.Student_ID
    },
    changeSelection(val) {
      this.multipleSelection = val
      this.spdSelection = val
    },
    backtoClassList() {
      this.$refs.classListShowModal.show()
    },
    async getParentClassList() {
      try {
        const response = await DataSource.shared.getParentClassList('', 'GET CLASS LIST GROUP BY LEVEL, SEMESTER, SCHOOL AND CLASS NAME')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('Error! getParentClassList')
          } else {
            this.parentClassListInt = response.Table
            this.parentClassListInt.forEach(object => {
              const foundLevel = this.classListFilteritem.find(d => d === object.CRS_Course_Name)
              if (!foundLevel) {
                this.classListFilteritem.push(object.CRS_Course_Name)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getClass() {
      try {
        const response = await DataSource.shared.getClass('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.classListInt = response.Table
            // this.classListInt.forEach(object => {
            //     const found = this.classListFilteritem.find(d => d === object.CLS_Batch);
            //     if (!found) {
            //         this.classListFilteritem.push(object.CLS_Batch);
            //     }
            //     const foundLevel = this.classListFilteritem.find(d => d === object.CRS_Course_Name);
            //     if (!foundLevel) {
            //         this.classListFilteritem.push(object.CRS_Course_Name);
            //     }
            // });

            let classListList = response.Table
            this.classListInt = classListList.filter(d => {
              return (
                d.CLS_FK_Semester_ID === this.classListSemesterID &&
                d.CLS_FK_Course_ID === this.classListCourseID &&
                d.CLS_ClassName === this.classListClassName
              )
            })

            this.currentClassProgs = this.classListInt.map(d => d.CLS_Batch)
          }
        }

        const totalStudentsInClassResponse = await DataSource.shared.getClassStudentList(
          this.classListSemesterID,
          this.classListCourseID,
          this.classListClassName,
        )
        if (totalStudentsInClassResponse) {
          if (totalStudentsInClassResponse.code === '88') {
            window.location.replace('/')
          } else if (totalStudentsInClassResponse.code === '99') {
            console.log('Error! in getClassStudentList')
          } else if (totalStudentsInClassResponse.code === '2') {
            console.log('No student in this class')
          } else {
            this.totalNumberOfStudentAssignedToClass = totalStudentsInClassResponse.Table.length
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getLevel() {
      try {
        const response = await DataSource.shared.getLevel('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.levelList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getAcademicYear() {
      try {
        const response = await DataSource.shared.getAcademicYear('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.semesterList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getClassType() {
      try {
        const response = await DataSource.shared.getClassType('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.classTypeList = response.Table
            //
            // this.classTypeList = this.classTypeList.filter(d => d.ID !== fileId);
            //
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getClassTeacher() {
      try {
        // const response = await DataSource.shared.getTeacherListBySchool();
        const response = await DataSource.shared.getTeacherPrinListBySchool()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('Error: Get Teacher List By School')
          } else {
            this.classTeacherList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getAllStaffListBySchool() {
      try {
        const response = await DataSource.shared.getAllStaffListBySchool()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('Error: Get All Staff List By School')
          } else {
            this.AllStaffListBySchoolList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      //if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    async saveClass() {
      try {
        if (
          this.programmeLevelID === '' ||
          this.programmeSemID === '' ||
          this.ddlClassType === '' ||
          this.programmeClassName === '' ||
          this.programmeMaxStudent === '' ||
          this.programmeSaveType === ''
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all information',
          })
        } else {
          const response = await DataSource.shared.saveClass(
            this.programmeLevelID,
            this.programmeSemID,
            this.ddlClassType,
            this.programmeClassName,
            this.programmeMaxStudent,
            this.programmeClassTeacher,
            this.programmeSaveType,
            JSON.stringify(this.programmeClassAssitantTeacher),
          )
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Save Class Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Duplicated Class with programme!',
              })
            } else {
              this.$notify({
                title: 'Success',
                message: 'Successfully Saved!',
                type: 'success',
              })
              window.location.replace('/ClassManagement')
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async updateClass() {
      try {
        if (this.editSemesterID === '' || this.editCourseID === '' || this.editClassName === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please close and open again',
          })
        } else if (this.inputEditClassName === '' || this.ddlEditClassStatus === '' || this.inputEditMaxStudents === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all information',
          })
        } else {
          //Assistant and Mandarin teacher
          let assitantTeacher = []

          if (this.ddlEditMandarinTeacher !== '' && this.ddlEditMandarinTeacher !== undefined && this.ddlEditMandarinTeacher !== null) {
            let mandarinTeacher = {
              ID: this.ddlEditMandarinTeacher,
              Role: 'Mandarin Teacher',
            }
            assitantTeacher.push(mandarinTeacher)
          }

          this.editClassAssitantTeacher.forEach(m => {
            let assistantTeacher = {
              ID: m.ID,
              Role: m.Role,
            }
            assitantTeacher.push(assistantTeacher)
          })

          const response = await DataSource.shared.updateClass(
            this.ddlEditClassStatus,
            this.inputEditClassName,
            this.inputEditMaxStudents,
            this.editClassName,
            this.editCourseID,
            this.editSemesterID,
            this.ddlEditClassTeacher,
            JSON.stringify(assitantTeacher),
            this.editClassID,
          )
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Edit Class Error!',
              })
            } else {
              this.$notify({
                title: 'Success',
                message: 'Successfully Edited!',
                type: 'success',
              })
              this.getParentClassList()
              this.closeAssignModal()
              window.location.replace('/ClassManagement')
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    directToPromotion() {
      window.location.replace('/Promotion')
    },
    directToTransferIn() {
      window.location.replace('/TransferIn')
    },
    directToStudentGraduation() {
      window.location.replace('/StudentGraduation')
    },
    assignStudentToClass(row) {
      return [
        {
          name: 'Assign',
          handler: _ => {
            this.assignClassLevelID = row.PK_Course_ID
            this.assignClassID = row.PK_Class_ID
            this.assignClassSemID = row.CLS_FK_Semester_ID
            this.getAssignStudents()
            // this.$refs.assignClassShowModal.show();
            this.assignClassModal = true
            this.tempRow = row
          },
        },
      ]
    },
    closeAssignModal() {
      this.assignClassModal = false
      this.newClassShowModal = false
      this.editClassShowModal = false
      this.newProgrammeShowModal = false
      this.ClassListModal = false
      this.ViewClassModal = false
    },
    ViewStudentToClass(row) {
      return [
        {
          name: 'View',
          handler: _ => {
            this.assignClassLevelID = row.PK_Course_ID
            this.assignClassID = row.PK_Class_ID
            this.assignClassSemID = row.CLS_FK_Semester_ID
            this.getAssignStudents()

            this.currentSemID = row.CLS_FK_Semester_ID
            this.currentCrsID = row.PK_Course_ID

            this.$refs.ViewClassModal.show()
          },
        },
      ]
    },
    ViewStudentToClassInner() {
      const row = this.tempRow
      this.assignClassLevelID = row.PK_Course_ID
      this.assignClassID = row.PK_Class_ID
      this.getAssignStudents()
      this.$refs.ViewClassModal.show()
    },
    returnAssignStudents() {
      this.$refs.assignClassShowModal.show()
    },
    async getAssignStudents() {
      try {
        this.multipleSelection = []
        this.viewStudentsSelectionList = []
        this.viewStudentsPendingSelectionList = []

        this.assignStudentsListInt = []
        this.currentStudent = []
        this.currentStudentPending = []

        this.$vs.loading()
        const response = await DataSource.shared.getActiveStudentsByLevelSchool(this.assignClassLevelID, this.assignClassID, this.assignClassSemID, 'YES', '')
        if (response) {
          this.$vs.loading.close()
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getActiveStudentsByLevelSchool error!')
          } else if (response.code === '2') {
            console.log('getActiveStudentsByLevelSchool no record!')
          } else {
            // response.Table.forEach(d => {
            let assignStudentList = response.Table

            this.assignStudentsListInt = assignStudentList.filter(d => {
              return d.assignToCurrentClass !== 'YES'
            })
            const assignedToCurrentClassStudentsList = assignStudentList.filter(d => {
              return d.assignToCurrentClass === 'YES'
            })
            this.assignStudentsListTotal = this.assignStudentsListInt.length
            this.assignStudentsListCurrentPage = 1
            this.assignStudentsListPageSize = 20

            assignedToCurrentClassStudentsList.forEach(object => {
              if (object.SCRS_Status === 'Active') {
                this.currentStudent.push(object)
              } else {
                this.currentStudentPending.push(object)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async assignClass() {
      this.$vs.loading()

      let classAssignList = []

      this.multipleSelection.forEach(item => {
        let classAssignDetials = {
          studentID: item.Student_ID,
          classHistoryID: item.PK_Student_Course_ID,
        }

        classAssignList.push(classAssignDetials)
      })

      const response = await DataSource.shared.massSetClass(this.assignClassID, JSON.stringify(classAssignList))
      if (response) {
        if (response.code === '1') {
          this.$notify({
            title: 'Success',
            message: 'Successfully saved',
            type: 'success',
          })
          this.closeAssignModal()
          this.getAssignStudents()
          // window.location.replace('/ClassManagement');
        } else if (response.code === '2') {
          this.$notify.error({
            title: 'Error',
            message: 'The class have been exceeded max number of student!',
          })
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Error! Please try again later',
          })
          window.location.replace('/ClassManagement')
        }
      }

      this.$vs.loading.close()
    },
    createNewProgrmamme(value) {
      if (value === 'New') {
        if (this.ddlClassLevel === '' || this.ddlSemester === '' || this.inputClassName === '' || this.inputMaxStudents === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all information',
          })
        } else {
          this.programmeLevelID = this.ddlClassLevel
          this.programmeSemID = this.ddlSemester
          this.programmeClassName = this.inputClassName
          this.programmeMaxStudent = this.inputMaxStudents
          this.programmeClassTeacher = this.ddlClassTeacher
          this.programmeSaveType = 'NEW CLASS'

          this.newProgrammeShowModal = true

          this.currentClassTypeList = this.classTypeList

          //Assistant and Mandarin teacher
          // this.programmeClassAssitantTeacher = this.ddlNewClassAssitantTeacher;
          this.programmeClassAssitantTeacher = []

          let mandarinTeacher = {
            ID: this.ddlMandarinTeacher,
            Role: 'Mandarin Teacher',
          }
          this.programmeClassAssitantTeacher.push(mandarinTeacher)

          this.newClassAssitantTeacher.forEach(m => {
            let assistantTeacher = {
              ID: m.ID,
              Role: m.Role,
            }
            this.programmeClassAssitantTeacher.push(assistantTeacher)
          })
        }
      } else if (value === 'Edit') {
        this.programmeLevelID = this.classListInt[0].CLS_FK_Course_ID
        this.programmeSemID = this.classListInt[0].CLS_FK_Semester_ID
        this.programmeClassName = this.classListInt[0].CLS_ClassName
        this.programmeMaxStudent = this.classListInt[0].CLS_Class_Max_Students
        this.programmeClassTeacher = this.classListInt[0].CLS_Class_Incharge_Staff
        this.programmeSaveType = 'NEW BATCH ONLY'

        this.newProgrammeShowModal = true

        this.currentClassTypeList = this.classTypeList.filter(d => {
          const found = this.currentClassProgs.find(c => {
            return d.CTY_ClassType === c
          })
          if (!found) {
            return d
          }
        })
      }
    },
    editClass() {
      this.editSemesterID = this.classListSemesterID
      this.editCourseID = this.classListCourseID
      this.editClassName = this.classListClassName
      this.editClassClassTeacher = this.classListClassTeacher
      this.inputEditClassName = this.classListClassName
      this.ddlEditClassStatus = 'Active'
      this.inputEditMaxStudents = this.classListMaxStudents
      this.inputeditLevel = this.classListLevelName
      // this.ddlEditClassTeacher = this.classListClassTeacher;
      // classListInt can hold more than one row when multiple batches (e.g.
      // Full Day / Half Day) share this class name. Capture the specific
      // PK_Class_ID here so the backend edits/reconciles only this row's
      // teacher assignments, instead of every batch sharing this name.
      this.editClassID = this.classListInt.length > 0 ? this.classListInt[0].PK_Class_ID : ''
      this.$refs.editClassShowModal.show()

      this.getClassesInchargeSpecialistStaff(this.classListCourseID, this.classListSemesterID, this.classListClassName, this.classListClassTeacher, this.editClassID)
    },
    assignStudentsListChangePage(currentPage) {
      this.assignStudentsListCurrentPage = currentPage
    },
    assignStudentsListChangePageSize(currentPageSize) {
      this.assignStudentsListPageSize = currentPageSize
    },
    async removeClassProgramme(classID) {
      try {
        const response = await DataSource.shared.updateClassProgramme(classID, 'VOID')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Remove Class Programme Error!',
            })
          } else {
            this.$notify({
              title: 'Success',
              message: 'Successfully Removed Programme!',
              type: 'success',
            })
            //this.closeAssignModal();
            window.location.replace('/ClassManagement')
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    classManagementPageVueTourStart() {
      this.$tours['classManagementPageVueTourName'].start()
    },
    classManagementPageVueTourCallBacksPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1

      this.tourCallBackStepsFunc(finalSteps)
    },
    classManagementPageVueTourCallBacksNextSteps(currentStep) {
      let finalSteps = currentStep + 1

      this.tourCallBackStepsFunc(finalSteps)
    },
    tourCallBackStepsFunc(finalSteps) {},
    tourStop() {
      this.$tours['classManagementPageVueTourName'].stop()
    },
    viewStudentsSelection(val) {
      this.viewStudentsSelectionList = val
      this.isClick = false
    },
    viewStudentsPendingSelection(val) {
      this.viewStudentsPendingSelectionList = val
      //console.log('val',val);
    },
    async printStudentCard() {
      try {
        let studentList = []
        this.viewStudentsSelectionList.forEach(item => {
          const stuFullName = [item.Full_Name, item.Last_name].filter(s => s?.length > 0).join(' ')

          let studentListTemp = {
            StudentID: item.Student_ID,
            FullName: stuFullName,
            IndexNo: item.Index_No,
            SemID: this.currentSemID,
            CrsID: this.currentCrsID,
          }

          studentList.push(studentListTemp)
        })

        this.viewStudentsPendingSelectionList.forEach(item => {
          const stuFullName = [item.Full_Name, item.Last_name].filter(s => s?.length > 0).join(' ')

          let studentListTemp = {
            StudentID: item.Student_ID,
            FullName: stuFullName,
            IndexNo: item.Index_No,
            SemID: this.currentSemID,
            CrsID: this.currentCrsID,
          }

          studentList.push(studentListTemp)
        })

        let studentListObjJson = {
          StudentList: studentList,
        }

        this.$vs.loading()

        const response = await DataSource.shared.generateClassStudentQRForPrinting(JSON.stringify(studentListObjJson))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Generate Student Card: Error',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'No records',
              message: 'No student found',
            })
          } else {
            let base64string = response.code

            var byteChar = atob(base64string)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: 'application/pdf;base64' })
            var fileUrl = URL.createObjectURL(file)
            window.open(fileUrl, '_blank', 'width=500, height=500')
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async printStudentClass() {
      try {
        let studentList = []
        console.log(this.viewStudentsSelectionList)
        this.viewStudentsSelectionList.forEach(item => {
          const stuFullName = [item.Full_Name, item.Last_name].filter(s => s?.length > 0).join(' ')

          let studentListTemp = {
            StudentID: item.Student_ID,
            FullName: stuFullName,
            IndexNo: item.Index_No,
            SemID: this.currentSemID,
            CrsID: this.currentCrsID,
          }

          studentList.push(studentListTemp)
        })

        this.viewStudentsPendingSelectionList.forEach(item => {
          const stuFullName = [item.First_Name, item.Middle_Name, item.Last_Name, item.St_Preferred_Name].filter(s => s?.length > 0).join(' ')

          let studentListTemp = {
            StudentID: item.Student_ID,
            FullName: stuFullName,
            IndexNo: item.Index_No,
            SemID: this.currentSemID,
            CrsID: this.currentCrsID,
          }

          studentList.push(studentListTemp)
        })

        let studentListObjJson = {
          StudentList: studentList,
        }

        this.$vs.loading()

        const response = await DataSource.shared.generateClassStudentForPrinting(JSON.stringify(studentListObjJson))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Generate Student Card: Error',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'No records',
              message: 'No student found',
            })
          } else {
            let base64string = response.code

            var byteChar = atob(base64string)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: 'application/pdf;base64' })
            var fileUrl = URL.createObjectURL(file)
            window.open(fileUrl, '_blank', 'width=500, height=500')
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getClassesInchargeSpecialistStaff(levelID, semesterID, className, classTeacherID, classID) {
      try {
        this.ddlEditClassAssitantTeacher = ''
        this.ddlEditMandarinTeacher = []
        this.ddlEditClassTeacher = ''
        this.editClassAssitantTeacher = []

        const response = await DataSource.shared.getClassesInchargeSpecialistStaff(levelID, semesterID, className, classID)
        if (response) {
          this.ddlEditClassTeacher = classTeacherID
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getClassesInchargeSpecialistStaff Error')
          } else if (response.code === '2') {
            console.log('getClassesInchargeSpecialistStaff No Record')
          } else {
            response.Table.forEach(resData => {
              // let checkGroupByUser = this.ddlEditClassAssitantTeacher.filter(m => m === resData.CissUserID);
              //
              // if (checkGroupByUser.length < 1) {
              //     this.ddlEditClassAssitantTeacher = this.ddlEditClassAssitantTeacher.concat(resData.CissUserID);
              // }

              // this.ddlEditClassTeacher = classTeacherID;

              if (resData.CissType === 'Mandarin Teacher') {
                this.ddlEditMandarinTeacher = resData.CissUserID
              } else {
                let classTeacherList = this.classTeacherList.filter(m => m.CONid === resData.CissUserID)

                if (classTeacherList.length > 0) {
                  //filter same class name but different class id, eg, full day and half day
                  let classIDTeacherFilter = this.editClassAssitantTeacher.filter(m => m.ID === resData.CissUserID)

                  if (classIDTeacherFilter.length < 1) {
                    let currentTeacher = {
                      ID: resData.CissUserID,
                      Role: resData.CissType,
                      Name: classTeacherList[0].CONname,
                    }

                    this.editClassAssitantTeacher.push(currentTeacher)
                  }
                }
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    showScheduleClassModal(row) {
      this.assignScheduleStudentsListInt = []
      this.inputscheduleClassDate = ''

      this.scheduleClassID = row.PK_Class_ID
      this.assignClassLevelID = row.PK_Course_ID
      this.assignClassSemID = row.CLS_FK_Semester_ID
      this.$refs.scheduleClassShowModal.show()
    },
    async getScheduleAssignStudents() {
      try {
        this.multipleScheduleSelection = []
        this.assignScheduleStudentsListInt = []

        this.$vs.loading()
        const response = await DataSource.shared.getActiveStudentsByLevelSchool(
          this.assignClassLevelID,
          this.scheduleClassID,
          this.assignClassSemID,
          'YES',
          this.inputscheduleClassDate,
        )
        if (response) {
          this.$vs.loading.close()
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getActiveStudentsByLevelSchool error!')
          } else if (response.code === '2') {
            console.log('getActiveStudentsByLevelSchool no record!')
          } else {
            let assignScheduleStudentList = response.Table

            this.assignScheduleStudentsListInt = assignScheduleStudentList.filter(d => {
              return d.assignToCurrentClass !== 'YES' && d.assignScheduleToCurrentClass !== 'YES'
            })

            this.assignScheduleStudentsListTotal = this.assignScheduleStudentsListInt.length
            this.assignScheduleStudentsListCurrentPage = 1
            this.assignScheduleStudentsListPageSize = 20
          }
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    assignScheduleStudentsListChangePage(currentPage) {
      this.assignScheduleStudentsListCurrentPage = currentPage
    },
    assignScheduleStudentsListChangePageSize(currentPageSize) {
      this.assignScheduleStudentsListPageSize = currentPageSize
    },
    changeScheduleSelection(val) {
      this.multipleScheduleSelection = val
    },
    changePendingSelection(val) {
      this.multiplePendingSelection = val
      console.log(this.multiplePendingSelection.length)
    },
    async assignScheduleClass() {
      let scheduleClassAssignList = []

      this.multipleScheduleSelection.forEach(item => {
        let scheduleClassAssignDetails = {
          scrID: item.PK_Student_Course_ID,
          newClassID: this.scheduleClassID,
          effectiveDate: this.inputscheduleClassDate,
        }

        scheduleClassAssignList.push(scheduleClassAssignDetails)
      })

      const response = await DataSource.shared.saveScheduleStudentClass(JSON.stringify(scheduleClassAssignList))
      if (response) {
        this.$vs.loading.close()
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('saveScheduleStudentClass error!')
        } else {
          this.$notify({
            title: 'Successfully',
            message: 'Successfully Saved!',
          })

          this.$refs.scheduleClassShowModal.hide()
        }
      }
    },
    async printAllStudent() {
      try {
        this.modal = null
        this.$refs.showPrintAllStudentModal.show()
      } catch (e) {
        this.results = e
      }
    },
    async printAllStudentQR() {
      try {
        this.modal = {
          isQR: true,
        }
        this.$refs.showPrintAllStudentModal.show()
      } catch (e) {
        this.results = e
      }
    },
    setTags(value) {
      console.log('setTags', value)
      try {
        this.tags = value
      } catch (e) {
        this.results = e
      }
    },
    AddComponentValue() {
      try {
        if (this.tags) {
          let spdList = []
          this.tags.forEach(m => {
            if (!m.SF_File_Name) {
              m.SF_File_Name = ''
            }

            const stuFullName = [m.First_Name, m.Middle_Name, m.Last_Name, m.St_Preferred_Name].filter(s => s?.length > 0).join(' ')

            let list = {
              StudentID: m.Student_ID,
              FullName: stuFullName,
              SF_File_Name: m.SF_File_Name,
              IndexNo: m.Index_No,
              SemID: m.PK_Semester_ID,
              CrsID: m.PK_Course_ID,
              CRS_Course_Name: m.CRS_Course_Name,
              CLS_ClassName: m.CLS_ClassName,
              SMT_Code: m.SMT_Code,
              CLS_Batch: m.CLS_Batch,
            }
            spdList.push(list)
          })
          this.SelectedStudentListInt = spdList

          this.$notify({
            title: 'Success',
            message: 'Successfully!',
            type: 'success',
          })
          this.$refs.addClassModal.hide()
        } else if (this.SelectedStudentListInt) {
          this.$notify.error({
            title: 'Error, No selected student, please try again',
            message: 'Error',
          })
        } else {
          this.$notify.error({
            title: 'Error, please try again',
            message: 'Error',
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    getActiveTeacher() {
      let FinalReturnTable = []

      if (this.classTeacherList.length > 0) {
        this.classTeacherList.forEach(m => {
          if (m.CONid !== this.ddlClassTeacher && m.CONid !== this.ddlMandarinTeacher) {
            let checkID = this.newClassAssitantTeacher.filter(m2 => m2.ID === m.CONid)

            if (checkID.length < 1) {
              FinalReturnTable.push(m)
            }
          }
        })
      }

      return FinalReturnTable
    },
    getActiveEditTeacher() {
      let FinalReturnTable = []

      if (this.classTeacherList.length > 0) {
        this.classTeacherList.forEach(m => {
          if (m.CONid !== this.ddlEditClassTeacher && m.CONid !== this.ddlEditMandarinTeacher) {
            let checkID = this.editClassAssitantTeacher.filter(m2 => m2.ID === m.CONid)

            if (checkID.length < 1) {
              FinalReturnTable.push(m)
            }
          }
        })
      }

      return FinalReturnTable
    },
    EditAddRole() {
      if (this.ddlEditClassAssitantTeacher === '' || this.ddlEditClassRoleSelection === '') {
        this.$notify.error({
          title: 'Required',
          message: 'Please select teacher and insert role...',
        })
      } else if (this.inputeditClassAssitantTeacherRole === 'Mandarin Teacher' || this.inputeditClassAssitantTeacherRole === 'Mandarin') {
        this.$notify.error({
          title: 'Duplicated',
          message: 'Please use dropdown for Mandarin Teacher...',
        })
      } else if (this.ddlEditClassRoleSelection === 'Other' && this.inputeditClassAssitantTeacherRole === '') {
        this.$notify.error({
          title: 'Required',
          message: 'Please select teacher and insert role...',
        })
      } else {
        let editNewRole
        if (this.ddlEditClassRoleSelection === 'Other') {
          editNewRole = this.inputeditClassAssitantTeacherRole
        } else {
          editNewRole = this.ddlEditClassRoleSelection
        }

        //check core and mandarin teacher
        if (this.ddlEditClassAssitantTeacher === this.ddlEditClassTeacher || this.ddlEditClassAssitantTeacher === this.ddlEditMandarinTeacher) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated teacher...',
          })

          return
        }

        //check if added role or teacher
        let checkTeacher = this.editClassAssitantTeacher.filter(m => m.ID === this.ddlEditClassAssitantTeacher)
        let checkRole = this.editClassAssitantTeacher.filter(m => m.Role === editNewRole)

        if (checkTeacher.length > 0) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated teacher...',
          })

          return
        }

        if (checkRole.length > 0) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated role...',
          })

          return
        }

        //get teacher name
        let classTeacherList = this.classTeacherList.filter(m => m.CONid === this.ddlEditClassAssitantTeacher)

        if (classTeacherList.length > 0) {
          let currentTeacher = {
            ID: this.ddlEditClassAssitantTeacher,
            Role: editNewRole,
            Name: classTeacherList[0].CONname,
          }

          this.editClassAssitantTeacher.push(currentTeacher)

          this.ddlEditClassAssitantTeacher = ''
          this.inputeditClassAssitantTeacherRole = ''
          this.ddlEditClassRoleSelection = ''
        }
      }
    },
    AddRole() {
      if (this.ddlNewClassAssitantTeacher === '' || this.ddlNewClassRoleSelection === '') {
        this.$notify.error({
          title: 'Required',
          message: 'Please select teacher and insert role...',
        })
      } else if (this.inputnewClassAssitantTeacherRole === 'Mandarin Teacher' || this.inputnewClassAssitantTeacherRole === 'Mandarin') {
        this.$notify.error({
          title: 'Duplicated',
          message: 'Please use dropdown for Mandarin Teacher...',
        })
      } else if (this.ddlNewClassRoleSelection === 'Other' && this.inputnewClassAssitantTeacherRole === '') {
        this.$notify.error({
          title: 'Required',
          message: 'Please select teacher and insert role...',
        })
      } else {
        let insertNewRole
        if (this.ddlNewClassRoleSelection === 'Other') {
          insertNewRole = this.inputnewClassAssitantTeacherRole
        } else {
          insertNewRole = this.ddlNewClassRoleSelection
        }

        //check core and mandarin teacher
        if (this.ddlNewClassAssitantTeacher === this.ddlClassTeacher || this.ddlNewClassAssitantTeacher === this.ddlMandarinTeacher) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated teacher...',
          })

          return
        }

        //check if added role or teacher
        let checkTeacher = this.newClassAssitantTeacher.filter(m => m.ID === this.ddlNewClassAssitantTeacher)
        let checkRole = this.newClassAssitantTeacher.filter(m => m.Role === insertNewRole)

        if (checkTeacher.length > 0) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated teacher...',
          })

          return
        }

        if (checkRole.length > 0) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated role...',
          })

          return
        }

        //get teacher name
        let classTeacherList = this.classTeacherList.filter(m => m.CONid === this.ddlNewClassAssitantTeacher)

        if (classTeacherList.length > 0) {
          let currentTeacher = {
            ID: this.ddlNewClassAssitantTeacher,
            Role: insertNewRole,
            Name: classTeacherList[0].CONname,
          }

          this.newClassAssitantTeacher.push(currentTeacher)

          this.ddlNewClassAssitantTeacher = ''
          this.inputnewClassAssitantTeacherRole = ''
          this.ddlNewClassRoleSelection = ''
        }
      }
    },
    ClearSelectedItems() {
      try {
        console.log('Clear')
        this.SelectedStudentListInt = []
      } catch (e) {
        this.results = e
      }
    },
    displayPdf(base64string) {
      var byteChar = atob(base64string)
      var byteNo = new Array(byteChar.length)
      for (var i = 0; i < byteChar.length; i++) {
        byteNo[i] = byteChar.charCodeAt(i)
      }

      var byteArray = new Uint8Array(byteNo)
      var file = new Blob([byteArray], { type: 'application/pdf;base64' })
      var fileUrl = URL.createObjectURL(file)
      window.open(fileUrl, '_blank', 'width=500, height=500')
      // window.print(fileUrl, '_blank', 'width=500, height=500');
    },
    async PrintPreviewBtnClick() {
      this.$vs.loading()
      try {
        if (this.tags.length > 50) {
          this.$notify.error({
            title: 'Message',
            message: 'Max 50 students per print!',
          })
        }
        let studentListObjJson = {
          StudentList: this.SelectedStudentListInt,
        }
        let resp
        if (this.modal && this.modal.isQR) {
          resp = await DataSource.shared.generateClassStudentQRForPrinting(JSON.stringify(studentListObjJson))
        } else {
          resp = await DataSource.shared.generateClassStudentForPrinting(JSON.stringify(studentListObjJson))
        }
        if (resp) {
          switch (resp.code) {
            case '1':
              console.log('Print success!')
              break
            case '2':
              console.log('Cannot find student record!')
              break
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'cannot print student card!',
              })
              break

            default:
              this.displayPdf(resp.code)
              this.SelectedStudentListInt = []
          }
        }
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },
    AddComponentBarcode() {
      try {
        if (this.tags.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Error, No selected student, please try again',
          })
        } else if (this.tags) {
          let spdList = []
          this.tags.forEach(m => {
            if (!m.SF_File_Name) {
              m.SF_File_Name = ''
            }

            const stuFullName = [m.First_Name, m.Middle_Name, m.Last_Name, m.St_Preferred_Name].filter(s => s?.length > 0).join(' ')

            let list = {
              StudentID: m.Student_ID,
              FullName: stuFullName,
              SF_File_Name: m.SF_File_Name,
              ID_Type: m.ID_TYPE,
              BirthCertNo: m.BirthCertNo,
              NRIC: m.NRIC,
              ID_Number: m.ID_NUMBER,
              Passport_Number: m.Passport_Number,
              IndexNo: m.Index_No,
              SemID: m.PK_Semester_ID,
              CrsID: m.PK_Course_ID,
              CRS_Course_Name: m.CRS_Course_Name,
              CLS_ClassName: m.CLS_ClassName,
              SMT_Code: m.SMT_Code,
              CLS_Batch: m.CLS_Batch,
              Nationality: m.Nationality,
            }
            spdList.push(list)
          })
          this.SelectedStudentListInt = spdList

          this.$notify({
            title: 'Success',
            message: 'Added Successfully!',
            type: 'success',
          })
          this.$refs.addClassModal.hide()
        } else {
          this.$notify.error({
            title: 'Error, please try again',
            message: 'Error',
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async PrintBarcode() {
      this.$vs.loading()
      try {
        if (this.tags.length > 80) {
          this.$notify.error({
            title: 'Message',
            message: 'Max 80 students per print!',
          })
        }

        let studentListObjJson = {
          StudentList: this.SelectedStudentListInt,
        }

        const resp = await DataSource.shared.printStudentNameAndBarcode(JSON.stringify(studentListObjJson), 'Yes')
        if (resp) {
          switch (resp.code) {
            case '1':
              console.log('Print success!')
              break
            case '2':
              console.log('Cannot find student record!')
              break
            case '88':
              this.$router.push('/')
              break
            case '99':
              this.$notify.error({
                title: 'Error',
                message: 'cannot print student barcode!',
              })
              break

            default:
              this.displayPdf(resp.code)
              this.SelectedStudentListInt = []
              this.tags = []
              this.$refs.printBarcodeModal.hide()
              this.$refs.refReset.resetSelectedObj()
          }
        }
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },
    async btnPrintBarcodeClick() {
      try {
        this.$refs.printBarcodeModal.show()
      } catch (e) {
        this.results = e
      }
    },
    async printPendingSafeEntry(value) {
      try {
        let studentList = []
        let mode = 'Pending'
        if (value === 'PrintAllSafeEntry') {
          this.multiplePendingSelection.forEach(item => {
            const stuFullName = [item.First_Name, item.Middle_Name, item.Last_Name, item.St_Preferred_Name].filter(s => s?.length > 0).join(' ')

            let studentListTemp = {
              StudentID: item.Student_ID,
              FullName: stuFullName,
              IndexNo: item.Index_No,
              SemID: item.PK_Semester_ID,
              CrsID: item.PK_Course_ID,
              BirthCertNo: item.BirthCertNo,
              NRIC: item.NRIC,
              ID_Number: item.ID_NUMBER,
              Passport_Number: item.Passport_Number,
              CRS_Course_Name: item.CRS_Course_Name,
              CLS_ClassName: item.CLS_ClassName,
              SMT_Code: item.SMT_Code,
              CLS_Batch: item.CLS_Batch,
              Nationality: item.Nationality,
            }

            studentList.push(studentListTemp)
          })
        } else {
          this.viewStudentsPendingSelectionList.forEach(item => {
            const stuFullName = [item.First_Name, item.Middle_Name, item.Last_Name, item.St_Preferred_Name].filter(s => s?.length > 0).join(' ')

            let studentListTemp = {
              StudentID: item.Student_ID,
              FullName: stuFullName,
              IndexNo: item.Index_No,
              SemID: this.currentSemID,
              CrsID: this.currentCrsID,
              ID_Type: item.ID_Type,
              BirthCertNo: item.St_BirthCer_Number,
              NRIC: item.St_IC_ID_Number,
              ID_Number: item.ID_Number,
              Passport_Number: item.St_Passport_Number,
              CRS_Course_Name: item.CRS_Course_Name,
              CLS_ClassName: item.CLS_ClassName,
              SMT_Code: item.SMT_Code,
              CLS_Batch: item.CLS_Batch,
              Nationality: item.Nationality,
            }

            studentList.push(studentListTemp)
          })
        }

        let studentListObjJson = {
          StudentList: studentList,
        }

        this.$vs.loading()

        const response = await DataSource.shared.printStudentNameAndBarcode(JSON.stringify(studentListObjJson), mode)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Generate SafeEntry Card: Error',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'No records',
              message: 'No student found',
            })
          } else {
            this.displayPdf(response.code)
            this.$refs.ViewClassModal.hide()
            this.multiplePendingSelection = []
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    getAllPendingStudent() {
      //todo keyword "WithPending" to get pending&active student.
      DataSource.shared.getAllActiveStudentsBySchoolWithMode('WithPending').then(result => {
        if (result.code === '88') {
          window.location.replace('/')
          return
        } else if (result.code === '99') {
          return
        } else if (result.code === '2') {
          return
        } else {
          this.allPendingStudentInt = result.Table
          //this.allPendingStudentList = this.allPendingStudentInt;
          this.allPendingStudentInt.forEach(object => {
            const foundLevel = this.PendingClassListFilteritem.find(d => d === object.CRS_Course_Name)
            if (!foundLevel) {
              this.PendingClassListFilteritem.push(object.CRS_Course_Name)
            }
          })
          return this.allPendingStudentInt
        }
      })
    },
    openClassCoordinator() {
      this.getClassCoordinator()
      this.$refs.classCoordinatorModel.show()
    },
    async getClassCoordinator() {
      try {
        this.$vs.loading()

        this.coordinatorClassListInt = []
        this.mainCoordinatorClassList = []

        const response = await DataSource.shared.getClassCoordinator()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getClassCoordinator error!')
          } else if (response.code === '2') {
            console.log('getClassCoordinator no record!')
          } else {
            this.mainCoordinatorClassList = response.mainCoordinator.Table

            response.activeClass.Table.forEach(item => {
              let getAssigned = response.coordinatorList.Table.filter(m => m.TeRpFlowClassID === item.PK_Class_ID)

              let assignedList = []

              if (getAssigned.length > 0) {
                getAssigned.forEach(itemGetAssigned => {
                  let tempObject = {
                    ConID: itemGetAssigned.TeRpFlowConID,
                    Name: itemGetAssigned.CONname,
                    Level: itemGetAssigned.TeRpFlowLevel,
                  }

                  assignedList.push(tempObject)
                })
              }

              let followMain = this.checkCoordinatorMainNonMain(item.PK_Class_ID, assignedList)

              let temp = {
                ClassID: item.PK_Class_ID,
                ClassName: item.CLS_ClassName,
                ClassBatch: item.CLS_Batch,
                ClassFullName: item.CLS_ClassName + ' (' + item.CLS_Batch + ' )',
                SemID: item.PK_Semester_ID,
                SemName: item.SMT_Code,
                CrsID: item.PK_Course_ID,
                CrsName: item.CRS_Course_Name,
                CoorList: assignedList,
                followMain: followMain,
              }

              this.coordinatorClassListInt.push(temp)
            })
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    checkCoordinatorMainNonMain(classID, coorList) {
      let followMain = true

      if (coorList.length > 0) {
        if (coorList.length === this.mainCoordinatorClassList.length) {
          coorList.forEach(item => {
            if (followMain) {
              let check = this.mainCoordinatorClassList.filter(m => m.TeRpFlowLevel === item.Level.toString())
              if (check.length > 0) {
                if (check[0].TeRpFlowConID !== item.ConID) {
                  followMain = false
                }
              } else {
                followMain = false
              }
            }
          })
        } else {
          followMain = false
        }
      } else {
        followMain = false
      }

      return followMain
    },
    updateCoordinatorModel(list) {
      this.currentCoordinatorClassList = list
      this.updateCoordinatorClassList = []
      this.updateCoordinatorClassTeacher = ''
      this.updateCoordinatorClassLevel = 1
      this.$refs.updateCoordinatorModel.show()
    },
    addCoorToList() {
      let check = this.updateCoordinatorClassList.filter(m => m.ConID === this.updateCoordinatorClassTeacher)

      if (check.length > 0) {
        this.$notify.error({
          title: 'Duplicated',
          message: 'This coordinator have added...',
        })
      } else {
        let getConName = this.AllStaffListBySchoolList.filter(m => m.CONid === this.updateCoordinatorClassTeacher)

        if (getConName.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Error...',
          })
        } else {
          let temp = {
            ConID: this.updateCoordinatorClassTeacher,
            Name: getConName[0].CONname,
            Level: this.updateCoordinatorClassLevel,
          }

          this.updateCoordinatorClassList.push(temp)

          this.updateCoordinatorClassLevel = this.updateCoordinatorClassList.length + 1
        }
      }
    },
    async updateClassCoordinator() {
      try {
        this.$vs.loading()

        let list = {
          ClassID: this.currentCoordinatorClassList.ClassID,
          List: this.updateCoordinatorClassList,
        }

        const response = await DataSource.shared.updateClassCoordinator(JSON.stringify(list))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('updateClassCoordinator error!')
          } else {
            this.openClassCoordinator()
            this.$refs.updateCoordinatorModel.hide()
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    openStudentEmail() {
      this.getStudentsEmailBySchool()
      this.$refs.studentEmailModel.show()
    },
    async getStudentsEmailBySchool() {
      try {
        this.$vs.loading()

        this.studentEmailListActiveEmailInt = []
        this.studentEmailListNonActiveEmailInt = []
        this.showActiveEmailList = true
        this.studentEmailSelection = []
        this.inputSearchStudentEmailListActiveEmail = ''
        this.inputSearchStudentEmailListNonActiveEmail = ''

        const response = await DataSource.shared.getStudentsEmailBySchool()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getStudentsEmailBySchool error!')
          } else if (response.code === '2') {
            console.log('getStudentsEmailBySchool no record!')
          } else {
            response.Table.forEach(m => {
              if (m.Status === 'Yes') {
                this.studentEmailListActiveEmailInt.push(m)
              } else {
                this.studentEmailListNonActiveEmailInt.push(m)
              }
            })
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    loadStudentEmailList() {
      if (this.showActiveEmailList) {
        this.showActiveEmailList = false
      } else {
        this.showActiveEmailList = true
      }
    },
    changeStudentEmailSelection(val) {
      this.studentEmailSelection = val
    },
    async createStudentEmail() {
      if (this.studentEmailSelection.length > 0) {
        try {
          this.$vs.loading()

          let studentIndex = []

          this.studentEmailSelection.forEach(m => {
            let temp = {
              studentIndexNo: m.IndexNo,
            }

            studentIndex.push(temp)
          })

          const response = await DataSource.shared.studentEmailActionByBatch('Create', JSON.stringify(studentIndex))
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Email Action Error!',
              })
            } else {
              this.$notify({
                title: 'Success',
                message: 'Email successfully created!',
              })

              this.getStudentsEmailBySchool()
            }
          }

          this.$vs.loading.close()
        } catch (e) {
          this.results = e
        }
      } else {
        this.$notify.error({
          title: 'Required',
          message: 'Please Select Student...',
        })
      }
    },
    filterActiveStudentEmailList() {
      if (this.inputSearchStudentEmailListActiveEmail === '') {
        return this.studentEmailListActiveEmailInt
      } else {
        return this.studentEmailListActiveEmailInt.filter(
          data =>
            (data.FirstName && data.FirstName.toLowerCase().includes(this.inputSearchStudentEmailListActiveEmail.toLowerCase())) ||
            (data.Class && data.Class.toLowerCase().includes(this.inputSearchStudentEmailListActiveEmail.toLowerCase())) ||
            (data.Level && data.Level.toLowerCase().includes(this.inputSearchStudentEmailListActiveEmail.toLowerCase())),
        )
      }
    },
    filterNonActiveStudentEmailList() {
      if (this.inputSearchStudentEmailListNonActiveEmail === '') {
        return this.studentEmailListNonActiveEmailInt
      } else {
        return this.studentEmailListNonActiveEmailInt.filter(
          data =>
            (data.FirstName && data.FirstName.toLowerCase().includes(this.inputSearchStudentEmailListNonActiveEmail.toLowerCase())) ||
            (data.Class && data.Class.toLowerCase().includes(this.inputSearchStudentEmailListNonActiveEmail.toLowerCase())) ||
            (data.Level && data.Level.toLowerCase().includes(this.inputSearchStudentEmailListNonActiveEmail.toLowerCase())),
        )
      }
    },
  },
}
</script>

<style scoped>
.actionDiv {
  text-align: right;
}
.actionDiv .btn-primary {
  display: inline;
  margin-left: 10px;
}
.totalNumberOfStudentAssignedToClass {
  margin: 10px 0 0 0;
}
.totalNumberOfStudentAssignedToClass label {
  display: inline-block !important;
  background: linear-gradient(#1d976c, #93f9b9);
  padding: 10px;
  border-radius: 10px;
}
.totalNumberOfStudentAssignedToClass label:hover {
  opacity: 0.8;
}
.coorNameNonMain {
  color: #e6a23c;
}
.coorNameLevel1NonMain {
  margin-left: 5px;
  background: #feeacc;
  color: #e6a23c;
  padding: 5px;
}
.coorNameLevel1Main {
  margin-left: 5px;
  background: #dde6fc;
  color: #426dff;
  padding: 5px;
}
.coorNoAssign {
  color: #91a3b6;
}
.coorModeList {
  padding: 10px 5px;
  margin-left: 5px !important;
  border-radius: 50%;
  background: #536170 !important;
  color: #ffffff !important;
  display: inline !important;
}
.coorModeEditNonMain {
  padding: 10px 5px;
  margin-left: 5px !important;
  border-radius: 50%;
  background: #e6a23c !important;
  color: #ffffff !important;
  display: inline !important;
}
.coorModeEditMain {
  padding: 10px 5px;
  margin-left: 5px !important;
  border-radius: 50%;
  background: #426dff !important;
  color: #ffffff !important;
  display: inline !important;
}
</style>
